var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavBoardRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 0.219971L6.65997 5.14996C17.04 19.1 25.02 34.82 30.18 51.43C35.35 68.03 37.71 85.51 37.14 102.89C36.58 120.27 33.09 137.55 26.82 153.77C20.56 169.99 11.54 185.13 0.280029 198.39L4.27002 201.78",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 6.08984L9.44995 9.07983",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0301 10.0601L13.05 14.4901",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0701 15.9399L15.5601 18.6099",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.05 20.3599L18.76 24.2699",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.67 26.21L20.98 28.54",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3 31.0601L23.75 34.4301",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5099 36.8699L25.6599 38.8499",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.77 42.1199L27.99 44.9199",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.51 47.8699L29.53 49.4899",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3799 53.48L31.4199 55.71",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.72 59.1199L32.64 60.3799",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.17 65.0701L34.0701 66.7201",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1299 70.5701L34.96 71.4601",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1299 76.8301L35.9299 77.8901",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.71 82.1699L36.49 82.6799",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 88.7L36.99 89.1599",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4 93.8501L37.1599 93.9801",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.45 100.62L37.1799 100.48",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.25 105.55L37.02 105.3",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8101 112.53L36.5701 111.79",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2801 117.21L36.0801 116.58",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3199 124.35L35.1599 123.02",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.47 128.77L34.3301 127.77",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9899 136.05L32.95 134.12",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.79 140.17L31.73 138.79",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37.77 147.53L29.89 145.02",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M33.29 151.33L28.35 149.59",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.73 158.75L26.05 155.67",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 162.22L24.2 160.11",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.89 169.65L21.46 166.01",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9301 172.77L19.29 170.32",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.28 180.17L16.13 176",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M18.06 182.89L13.62 180.11",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8701 190.23L10.05 185.55",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.49 192.58L7.26001 189.48",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78009 199.81L3.31006 194.65",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8 9.33987L41.79 9.32986L40.83 8.80988L41.23 8.37988L42.43 9.03989L42.78 9.56989L38.14 12.5999L37.74 11.9899L41.8 9.33987Z",
    fill: "#00CECE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.56 15.9099C41.96 16.8999 40.71 16.8399 40.06 15.7999C39.49 14.8799 39.97 13.7199 41.53 12.7499C43.11 11.7799 44.4 11.9299 44.99 12.8799C45.6 13.8799 45.06 14.9899 43.56 15.9099ZM41.9099 13.3999C40.6799 14.1499 40.22 14.9599 40.58 15.5399C40.98 16.1899 41.93 16.0399 43.14 15.2999C44.3 14.5899 44.8799 13.8199 44.4699 13.1599C44.1299 12.5899 43.1999 12.6099 41.9099 13.3999Z",
    fill: "#00CECE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M53.78 43.7699L54.21 43.6099L54.95 43.9699C56.69 44.8499 57.58 45.2099 58.37 44.9399C58.9 44.7499 59.3 44.3199 59.02 43.5399C58.85 43.0699 58.47 42.7599 58.18 42.5899L58.6 42.1899C59.03 42.4399 59.44 42.8699 59.66 43.4799C60.06 44.5999 59.46 45.3499 58.71 45.6199C57.75 45.9599 56.72 45.5399 55.27 44.8199L54.74 44.5399L54.72 44.5499L55.56 46.89L54.97 47.0999L53.78 43.7699Z",
    fill: "#00CECE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.05 50.4498C57.26 51.0398 56.06 50.6898 55.68 49.5298C55.34 48.4998 56.08 47.4898 57.81 46.9098C59.57 46.3298 60.79 46.7798 61.14 47.8398C61.51 48.9498 60.73 49.9098 59.05 50.4498ZM58.04 47.6198C56.67 48.0698 56.03 48.7398 56.25 49.3898C56.49 50.1198 57.45 50.1898 58.8 49.7498C60.09 49.3298 60.83 48.7198 60.59 47.9798C60.38 47.3598 59.47 47.1598 58.04 47.6198Z",
    fill: "#00CECE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M62.95 76.4399C62.84 76.6699 62.7 77.1899 62.77 77.6999C62.9 78.6499 63.54 78.8699 64 78.7999C64.77 78.6899 64.9999 77.9499 64.9099 77.2399L64.85 76.8299L65.4099 76.7599L65.4699 77.1699C65.5399 77.7099 65.91 78.3599 66.56 78.2699C67 78.2099 67.35 77.8799 67.26 77.1999C67.2 76.7599 66.95 76.3599 66.75 76.1499L67.26 75.8799C67.51 76.1399 67.79 76.6699 67.87 77.2599C68.01 78.3399 67.44 78.9199 66.77 78.9999C66.2 79.0799 65.68 78.7999 65.34 78.1599H65.32C65.28 78.8499 64.84 79.4699 64.07 79.5699C63.19 79.6899 62.3299 79.1099 62.1599 77.7899C62.0799 77.1699 62.2 76.6099 62.34 76.3099L62.95 76.4399Z",
    fill: "#00CECE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M65.83 84.0197C63.96 84.2197 62.8499 83.6298 62.7199 82.4098C62.6099 81.3298 63.5399 80.4998 65.3599 80.2898C67.2099 80.0898 68.31 80.7797 68.43 81.8997C68.55 83.0697 67.58 83.8397 65.83 84.0197ZM65.43 81.0398C64 81.1898 63.2299 81.7197 63.2999 82.3997C63.3799 83.1597 64.31 83.4298 65.71 83.2798C67.07 83.1398 67.92 82.6898 67.84 81.9198C67.77 81.2698 66.93 80.8798 65.43 81.0398Z",
    fill: "#00CECE"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1899 112.31L64.6899 112.43L64.8899 109.86L65.3799 109.9L68.7099 112.64L68.6499 113.45L65.2198 113.18L65.1599 113.95L64.5699 113.9L64.6299 113.13L63.1299 113.01L63.1899 112.31ZM65.2799 112.47L67.1199 112.61C67.4099 112.63 67.6999 112.66 67.9799 112.7V112.67C67.6699 112.48 67.4399 112.32 67.1999 112.15L65.4299 110.65H65.4099L65.2799 112.47Z",
    fill: "#00CECE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M65.45 118.27C63.58 118.07 62.6199 117.27 62.7499 116.05C62.8599 114.97 63.95 114.35 65.77 114.53C67.62 114.72 68.5499 115.63 68.4299 116.75C68.3099 117.91 67.2 118.46 65.45 118.27ZM65.6799 115.27C64.2499 115.12 63.39 115.47 63.32 116.15C63.24 116.91 64.0899 117.37 65.4999 117.52C66.8599 117.66 67.7799 117.41 67.8599 116.64C67.9299 115.99 67.1799 115.43 65.6799 115.27Z",
    fill: "#00CECE"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6599 152.97L60.3299 150.97L59.0499 150.32C59.0299 150.45 58.9999 150.57 58.9399 150.76C58.8099 151.16 58.5799 151.54 58.2799 151.8C57.9099 152.13 57.3399 152.32 56.6799 152.1C55.6499 151.76 55.1599 150.68 55.5399 149.55C55.7299 148.98 56.0599 148.55 56.2999 148.35L56.7799 148.71C56.5799 148.88 56.2699 149.26 56.1099 149.73C55.8899 150.4 56.1299 151.12 56.8299 151.35C57.5099 151.57 58.1499 151.28 58.4999 150.23C58.5999 149.93 58.6499 149.69 58.6899 149.48L61.0999 150.66L60.2599 153.17L59.6599 152.97Z",
    fill: "#00CECE"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M56.06 156.81C54.29 156.16 53.56 155.15 53.98 154C54.35 152.98 55.55 152.64 57.28 153.26C59.02 153.9 59.71 155 59.32 156.05C58.92 157.15 57.72 157.42 56.06 156.81ZM57.01 153.96C55.66 153.47 54.74 153.6 54.51 154.24C54.25 154.96 54.96 155.61 56.29 156.09C57.57 156.56 58.53 156.54 58.79 155.81C59.02 155.2 58.43 154.48 57.01 153.96Z",
    fill: "#00CECE"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9699 195.09C38.0699 194.97 38.17 194.8 38.27 194.61C38.79 193.54 38.44 192.53 37.77 191.9L37.7599 191.92C37.8899 192.34 37.8599 192.88 37.5099 193.38C36.9499 194.18 35.97 194.34 35.09 193.71C34.26 193.13 33.8899 192.02 34.5599 191.08C35.2399 190.11 36.4399 190.01 37.6199 190.84C38.5099 191.47 38.9899 192.29 39.1199 193.05C39.2199 193.69 39.1 194.35 38.77 194.97C38.67 195.17 38.5699 195.33 38.4899 195.44L37.9699 195.09ZM35.4799 193.07C36.1299 193.53 36.7799 193.43 37.1699 192.87C37.4299 192.5 37.4399 192 37.2299 191.6C37.1899 191.51 37.1199 191.42 37.0099 191.34C36.2599 190.83 35.4599 190.78 35.0099 191.42C34.6499 191.95 34.8399 192.61 35.4799 193.07Z",
    fill: "#00CECE"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2599 197.8C31.7499 196.67 31.3399 195.49 32.0699 194.51C32.7199 193.64 33.9699 193.66 35.4499 194.74C36.9399 195.85 37.2799 197.1 36.6099 198.01C35.8999 198.94 34.6699 198.85 33.2599 197.8ZM34.9899 195.34C33.8399 194.48 32.9099 194.34 32.5099 194.89C32.0499 195.51 32.5499 196.33 33.6799 197.18C34.7699 198 35.6999 198.25 36.1599 197.63C36.5499 197.1 36.1999 196.24 34.9899 195.34Z",
    fill: "#00CECE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBoardRight);
export default __webpack_public_path__ + "static/media/nav-board-right.f179bb58d7d3b0b6396573f126895abd.svg";
export { ForwardRef as ReactComponent };